'use client';

import { useCart } from '@modules/common/components/cart-provider';
import CartDropdown from '../cart-dropdown';

export default function CartButton() {
  const { snapshot, mutationVersion } = useCart();

  return (
    <CartDropdown cart={snapshot.cart} mutationVersion={mutationVersion} />
  );
}
